import loadable from '@loadable/component';

export const ImportedEventPageLoadable = loadable(
  () => import('./ImportedEventPage'),
  { resolveComponent: (module) => module.ImportedEventPage },
);
